import { FaChevronDown } from "react-icons/fa";


const LoadMore = ({ forPagination, onClick, isLoading }) => {
    return (
        <>
            {forPagination.next_page_url && <div className="col-12 d-flex justify-content-center align-items-center  mb-3">
                <div onClick={onClick} className=" px-3 py-2  mt-2 cursor-pointer bg-main shadow d-flex justify-content-center align-items-center" style={{ height: 40, width: "auto", borderRadius: 5 }}>

                    {!isLoading ?
                        <div className="d-flex justify-content-center align-items-center gap-2">
                            <p className="text-center my-auto fw-bold text-light">Load More</p>
                            <FaChevronDown size={12} className="mx-auto" color="#ffffff" />
                        </div>
                        :
                        <div className="spinner-border text-white" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    }
                </div>
            </div>}
        </>
    );
}

export default LoadMore;